<template>
  <v-container>
    <div
      class="display-2 mb-7 mt-5 font-weight-thin"
      color="primary"
    >{{$tc('entities.regType.title',2)}}</div>

    <alert-box v-model="alert.alerts" :type="alert.type"></alert-box>
    <btn-a rounded color="primary" @click="editItem" :access="$access.regType.edit">
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <table-grid
      :headers="headers"
      :items="items"
      :loading="loadingTable"
      :loadingAction="loadingDialog"
      :actions="actions"
      :page="pagination.page"
      :pageLength="lengthPaginationComp"
      @input="pagination.page = $event"
      @search="searchTable"
    />

    <dialog-d
      ref="dialogEdit"
      :title="$tc('entities.regType.title')"
      deleteButton="true"
      @confirm="saveItem(itemSelected,$refs.form.isValid())"
      @delete="deleteItem(itemSelected,true)"
      :loading="loadingDialog"
      :accessConfirm="$access.regType.edit"
      :accessDelete="$access.regType.delete"
      :alert="form.alert"
    >
      <regTypeForm
        ref="form"
        v-if="itemSelected"
        v-model="itemSelected"
        :environments="environments"
      />
    </dialog-d>
  </v-container>
</template>

<script>
import regTypeService from "@/services/regTypeService";
import environmentService from "@/services/environmentService";
import regTypeForm from "../components/forms/regTypes/regTypeForm";
import pageListMixing from "../mixins/pageLists/pageListMixing.js";
export default {
  mixins: [pageListMixing],
  components: { regTypeForm },

  data() {
    return {
      apiController: "regType",
      entityService: regTypeService,
      searchFields: ["description"],
      headers: [
        {
          text: this.$t("entities.regType.props.description"),
          align: "left",
          sortable: false,
          value: "description",
        },
        {
          text: this.$t("entities.regType.props.stageRequired"),
          align: "left",
          sortable: false,
          value: "stageRequired",
        },
        {
          text: this.$t("entities.regType.props.environmentId"),
          align: "left",
          sortable: false,
          value: "environmentDesc",
        },
        {
          text: this.$t("table.actions"),
          value: "action",
          sortable: false,
          align: "right",
        },
      ],
      actions: [
        {
          text: this.$t("edit"),
          icon: "mdi-pencil",
          handle: this.editItem,
          access: [this.$access.regType.edit, this.$access.regType.show],
        },
        {
          text: this.$t("delete"),
          icon: "mdi-delete",
          handle: this.deleteItem,
          access: this.$access.regType.delete,
        },
      ],
      environments: [],
    };
  },
  methods: {
    async getItems() {
      this.loadingTable = true;
      let res = await this.entityService.getAll(
        this.pagination.page,
        this.pagination.limit,
        this.search,
        this.searchFields
      );
      await this.getEnvironments();
      if (res.success) {
        this.items = res.data.data;
        this.pagination.total = res.data.total
        this.items.forEach((i) => {
          let env = this.environments.filter((e) => e.id == i.environmentId)[0];
          i.environmentDesc = env ? env.description : "";
        });
      } else {
        this.errorNotification(res.data);
      }

      this.loadingTable = false;
    },

    async getEnvironments() {
      let res = await environmentService.getAll();
      if (res.success) this.environments = res.data.data;
    },
    getModelDefault() {
      return {
        reportId: null,
        timeType: 3,
        trigger: {},
        regTypeFields: [],
      };
    },
  },
  async mounted() {
    await this.getItems();
  },
};
</script>